// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"86371f5a","111":"3ee8bb7d","229":"1d1a391a","257":"96c6eb4a","271":"a4b83635","291":"f53554c0","347":"447f0f79","446":"d3963afa","550":"0b47dae4","575":"842bdbec","833":"15f9f11e","916":"c6cba709","958":"8aab9f97"}[chunkId] + ".chunk.js";
};